import types from './types'
import { Building } from '@/api'
import { Message } from 'element-ui'

export default {

  async fetchBuildingList({ commit }) {
    let list = await Building.all()
    commit(types.SET_BUILDING_LIST, list)
  },

  async addBuilding({ commit }, payload) {
    let newBuilding = await Building.add(payload)
    commit(types.ADD_BUILDING, newBuilding)
    Message.success('新增楼栋成功！')
  },

  async updateBuilding({ commit, state }, updatedData) {
    let updatedBuilding = await Building.update(updatedData)
    commit(types.UPDATE_BUILDING, updatedBuilding)
    Message.success('修改楼栋成功！')
  },

  async deleteBuilding({ commit, state }, id) {
    try {
      await Building.delete(id)
      commit(types.DELETE_BUILDING, id)
      Message.success('删除楼栋成功！')
    } catch (e) {
      console.log(e)
    }
  }
}
